import { render, staticRenderFns } from "./SettingModule.vue?vue&type=template&id=8f20ebe2&"
import script from "./SettingModule.vue?vue&type=script&lang=ts&"
export * from "./SettingModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports